import { Box, Flex, Text} from '@chakra-ui/react';
import React from 'react';
import Planner from './Planner/Planner';
import Actions from './Actions/Actions';
import { useWebSocket } from '../internal/messaging/WebSocketContext';
import { motion, AnimatePresence } from 'framer-motion';

const Workspace = ({showWorkspace, setShowWorkspace, workspaceOpened, setWorkspaceOpened, isFirstTimeWorkspace }) => {
  // const [workspaceOpened, setWorkspaceOpened] = React.useState(false);
  const { messages } = useWebSocket();
  const plannerMessage = messages?.find(
    (message) =>
      message.type === 'planner_message' &&
      message.planner_message.port === 'planner'
  );

  const myActionMessages = messages
    ?.filter((message) => message.action_message?.port === 'action')
    .reduce((acc, message) => {
      const currentStep = message.action_message.current_step;
      const isStepExist = acc?.find(
        (step) => step.stepNumber === currentStep.number
      );

      if (isStepExist) {
        isStepExist.actionMessages.push(message.action_message.message);
        isStepExist.status = currentStep.status;
        isStepExist.percentage_complete = currentStep.percentage_complete;
      } else {
        acc.push({
          stepNumber: currentStep.number,
          stepHeading: currentStep.message,
          actionMessages: [message.action_message.message],
          status: currentStep.status,
          percentage_complete: currentStep.percentage_complete,
        });
      }

      return acc;
    }, []);

  if (!plannerMessage && myActionMessages?.length === 0) return null;

  if (isFirstTimeWorkspace()) {
    setShowWorkspace(true);
    setWorkspaceOpened(true);
  }

  if (showWorkspace) {
    return (
      <Box flex="2" backgroundColor={"#eff4fa"} paddingX={"2%"} paddingTop={"24px"}>
      <AnimatePresence>
        {plannerMessage && (
          <motion.div
            initial={{ x: '25%', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: '100%', opacity: 0 }}
            transition={{ type: 'tween', duration: 0.5 }}
            style={{ flex: '1', overflow: 'hidden' }}
          >

            <Box
              paddingY={0}
              // minW="320px"
              height="calc(80vh)" // Ensure the Workspace takes up full available height
              overflowY="auto" // Enable scrolling if content overflows
            >
              <Box 
                display="flex"
                justifyContent="left"
                alignItems="left"
                >
                  <Text fontWeight={500} marginY={0} color="#1d1d1d" fontSize="18px" fontFamily="sans-serif" paddingLeft={0} marginBottom={"16px"} alignItems={"center"}>
                    Workspace
                  </Text>
              </Box>
              <Flex flexDirection="column" gap={4}>
                {/* Adjust maxH for Planner and Actions */}
                <Box flex="1" overflow="auto">
                  <Planner
                    plannerMessage={plannerMessage}
                    myActionMessages={myActionMessages}
                    workspaceOpened={workspaceOpened}
                  />
                </Box>
                <Box flex="1" overflowY="auto">
                  <Actions myActionMessages={myActionMessages} />
                </Box>
              </Flex>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
      </Box>
    )
  }

  return null;
};

export default Workspace;
